export enum requests {
    token = '/auth/token',
    accountData = '/wallet/getsavedaccounts',
    applyPayment = '/wallet/deposit',
    claims = '/v1/claims',
    search = '/v1/search/',
    getMenus = '/v1/applications/users/menus',
    getApplications= '/v1/applications/users/applications',
    claimDetails = '/v1/claims/',
    getCurrencies = '/v1/system/currencies',
    getLocations = '/v1/system/locations',
    getCountries = '/v1/system/countries',
    getClaimEvents = '/v1/esb/claimid/',
    getPenaltyEvents = '/v1/esb/invoiceid/',
    getVehicleDetails = '/v1/vehicles/',
    getInvoiceDetails = '/v1/invoices/',
    getDocuments='/v1/documents/',
    getInvoiceClaims = '/claims',
    getInvoiceClaimsItems = '/claimsItems',
    getInvoiceDocuments = '/documents/',
    getMedia='/media',
    getReports = '/v1/reports/',
    createtReport = '/v1/reports/',
    getUsers = '/v1/users/',
    getUserEvents = '/v1/esb/UserId/',

  

    getAccountDetails = 'v1/wallets/externalaccounts',
    getDailyStats = '/v1/stats/documents/daily',
    entityData = '/v1/entites/',
    getTasks = '/v1/esb/tasks',
    getMessage = '/v1/esb/messages',
    getIdentificationErrors = '/v1/ids/requests/summaries/errors',
    getIdentificationErrorsInfo = '/v1/ids/requests/',
    manualIdentification = '/v1/ids/requests/manualidentification',
    changePassword = '/v1/auth/password',
    auth = '/v1/auth/',
    prices = '/v1/system/pricelogics',

    note = '/v1/ce/notes',

    getOrganizations = '/externalconfig/organizations/'
}
